import { getToken } from '@/utils/auth'
import service from '@/utils/request'
import util from '@/utils'

/** 获取公司钱包数据 */
export function getCompaynWallet() {
  return service.get('/backend/finance/branchwallet/list')
}

/** 提交保存公司钱包数据 */
export function saveCompaynWallet(data) {
  return service.post('/backend/finance/branchwallet/submit', data)
}

/** 获取公司钱包数据记录 */
export function getCompaynWalletRecords(params) {
  return service.get('/backend/finance/branchwallet/history', { params })
}

/** 获取用户提现记录 */
export function getExtractRecords(params) {
  return service.get('/backend/finance/member/list', { params })
}

/** 提交用户提现审核信息 */
export function auditMemberExtractInfo(data) {
  return service.post('/backend/finance/member/submit', data)
}

/** 月度交易流水报表 */
export function getOrderTransactionRecords(params) {
  return service.get(`/backend/finance/report/transaction/records`, { params })
}

/** 导出月度交易流水报表 */
export function exportOrderTransactionRecords(params) {
  return `${process.env.VUE_APP_BASE_API}/backend/finance/report/transaction/export?X-Access-Token=${getToken()}&${util.json2UrlParam(params)}`
}
